import * as Scrivito from "scrivito";

const RecentProjectsLinkWidget = Scrivito.provideWidgetClass(
  "RecentProjectsLinkWidget",
  {
    onlyInside: "RecentProjectsWidget",
    attributes: {
      link: "link",
      withIcon: "boolean",
      withProjectCountDescription: "boolean",
      iconName: "string",
      iconPrefix: "string",
      title: "string",
      description: "stringlist",
      widgetType: [
        "enum",
        { values: ["projects", "products", "wizards", "library"] },
      ],
    },
    extractTextAttributes: ["title"],
  },
);

export default RecentProjectsLinkWidget;
